import React, { useRef, useState, useContext } from 'react';
import './Statistics.scss';
import { WidthContext } from '../../WidthContext';

function Statistics4() {
  const stats = { 2002: [2, 46], 2007: [9, 41], 2012: [11, 46], 2017: [12, 40], 2022: [13, 28] };
  const barRight = useRef();
  const barLeft = useRef();
  const width = useContext(WidthContext);

  const [year, setYear] = useState('2007');
  const [currentStats, setCurrentStats] = useState(stats[year]);

  const handleInputChange = (e) => {
    let target = e.target;
    const min = target.min;
    const max = target.max;
    const val = target.value;
    const newStat = stats[val];

    target.style.backgroundSize = ((val - min) * 100) / (max - min) + '% 100%';
    setYear(val);
    setCurrentStats(newStat);
    if (width > 480) {
      barLeft.current.style.width = `${newStat[0]}%`;
      barRight.current.style.width = `${newStat[1]}%`;
    } else {
      barLeft.current.style.height = `${newStat[0]}%`;
      barRight.current.style.height = `${newStat[1]}%`;
    }
  };

  return (
    <figure className="statistics">
      <div className="statistics__graphic">
        <h3 className="statistics__graphic__title statistics__graphic__title-4">
          More first-time buyers are saving for a down payment by living with family and friends
        </h3>
        <div className="statistics__graphic__graph__copy statistics__graphic__graph__copy-mobile ">
          <span>lived with parents, friends, or relatives</span>
        </div>

        <div className="statistics__graphic__graph statistics__graphic__graph-4">
          <div className="bar bar-4">
            <div className="bar-left bar-left-4" ref={barLeft} />
            <div className="bar-left bar--right" ref={barRight} />
            <div className="bar-number bar-number-4">
              <span>{currentStats[0]} %</span>
              <span>{currentStats[1]} %</span>
            </div>
          </div>
          <div className="statistics__graphic__graph__copy statistics__graphic__graph__copy-4 ">
            <span>lived with parents, friends, or relatives</span>
            <span className="statistics__graphic__graph__copy-4--right">
              rented an apartment or house
            </span>
          </div>
          <div className="statistics__graphic__range">
            <input
              className="statistics__graphic__range__slider"
              type="range"
              step="5"
              min="2002"
              max="2022"
              defaultValue={year}
              onChange={(e) => {
                handleInputChange(e);
              }}
            />
            <div className="statistics__graphic__range__label">
              <span>1993</span>
              <span>1997</span>
              <span>2012</span>
              <span>2017</span>
              <span>2022</span>
            </div>
          </div>
        </div>

        <div className="statistics__graphic__graph__copy statistics__graphic__graph__copy-mobile ">
          <span>rented an apartment or house</span>
        </div>
      </div>
      <figcaption className="captions">Source: NAR, 2022</figcaption>
    </figure>
  );
}

export default Statistics4;
